import type {
	Balance,
	Bid,
	ChangeBidAmountCommand,
	ChangeBidDestinationCommand,
	CostRates,
	PaymentDetails,
	PlaceBidCommand,
	RequestBidChangeCommand,
} from '@sirius/contracts';

import { request } from '../client';

/** Мої ставки, найновіші першими. */
export const listMyBids = (): Promise<Bid[]> => request<Bid[]>('/bids');

/** Баланс: total / blocked / available. Рахує бекенд, тут лише показ. */
export const getMyBalance = (): Promise<Balance> => request<Balance>('/me/balance');

/**
 * Подача максимальної ставки. Депозит перевіряє й блокує бекенд; при нестачі
 * відповідь несе код INSUFFICIENT_DEPOSIT із сумами — див. ApiError.code.
 */
export const placeBid = (command: PlaceBidCommand): Promise<Bid> =>
	request<Bid>('/bids', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(command),
	});

/** Пряма зміна суми, доки ставка не винесена на торги. */
export const changeBidAmount = (bidId: string, command: ChangeBidAmountCommand): Promise<Bid> =>
	request<Bid>(`/bids/${bidId}/amount`, {
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(command),
	});

/** Інший порт призначення — до результату торгів, без запиту до оператора. */
export const changeBidDestination = (bidId: string, command: ChangeBidDestinationCommand): Promise<Bid> =>
	request<Bid>(`/bids/${encodeURIComponent(bidId)}/destination`, {
		method: 'PATCH',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(command),
	});

/** Скасування до виходу на торги. */
export const cancelBid = (bidId: string): Promise<Bid> => request<Bid>(`/bids/${bidId}/cancel`, { method: 'POST' });

/** Запит на підняття або скасування ставки, яка вже на майданчику. */
export const requestBidChange = (bidId: string, command: RequestBidChangeCommand): Promise<Bid> =>
	request<Bid>(`/bids/${bidId}/change-requests`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(command),
	});

/** Реквізити для оплати. Бачить лише автентифікований дилер; null — ще не заповнені. */
export const getPaymentDetails = (): Promise<PaymentDetails | null> =>
	request<PaymentDetails | null>('/payment-details');

/** Тарифи Cost Calculator із системи. Публічні: калькулятор бачать і гості. */
export const getCostRates = (): Promise<CostRates> => request<CostRates>('/rates');
